import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  ArticleStockGlobale,
  findFreresStocksByArticleIdApi,
} from "../../../_App/Redux/Slices/article/articleSlice";
import { Form, Modal, Spinner } from "react-bootstrap";
import {
  findDepotsBySocieteApi,
  ListDepotByOrganisation,
} from "../../../_App/Redux/Slices/depot/depotSlice";
import {
  SelectedOrganisation,
  societeId,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../../_App/Redux/Slices/organisations/organisationSlice";
import { useTranslation } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import { generateUniqueColor, StockArticle, StockOrganisation, StockOrganisationshow } from "../../../_App/Helpers/helpers";

const StockGlobale = ({
  article,
  setSelectedArticles,
  ShowModal,
  setShowModal,
}: any) => {
  /**gener les couleurs  */
 

  /************** */
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [listNewOrganisation, setlistNewOrganisation] = useState<any[]>([]);
  const listDepots = useAppSelector(ListDepotByOrganisation);
  const societe = useAppSelector(societeId);
  const organisationsconnecte = useAppSelector(SelectedOrganisation);

  const listOrganisations = useAppSelector(ListOrganisations);
  const [article_defectueux, setarticle_defectueux] = useState<boolean>(false);
  const [showtotalStock, setShowtotalStock] = useState(false);
  const [showDepots, setshowDepots] = useState(false);
  const [OrgDepots, setOrgDepots] = useState<null | string>(null);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setarticle_defectueux(event.target.checked);
  };
  useEffect(() => {
    if (organisationsconnecte && listOrganisations) {
      let copie = [...listOrganisations];
      copie = copie.filter((item) => item._id !== organisationsconnecte._id);
      copie.unshift(organisationsconnecte);
      setlistNewOrganisation(copie);
    }
  }, [organisationsconnecte, listOrganisations]);

  const stockGlobale = useAppSelector(ArticleStockGlobale);
  const [spinner, setspinner] = useState(false);

  useEffect(() => {
    if (article?._id) dispatch(findFreresStocksByArticleIdApi(article._id));
  }, [dispatch, article]);

  useEffect(() => {
    if (ShowModal) {
      if (societe) {
        dispatch(findDepotsBySocieteApi(societe));
        dispatch(allOrganisationsApi(societe));
      }
    }
  }, [ShowModal]);
  useEffect(() => {
    if (stockGlobale) {
      let nouveauTableau = stockGlobale
        ? stockGlobale.map((element: any) =>
            element ? element["article_id"] : null
          )
        : [];
      function removeDuplicates(objects: any[]) {
        let seen = new Set();
        return objects.filter((obj) => {
          if (seen.has(obj?._id)) {
            return false;
          }
          seen.add(obj?._id);
          return true;
        });
      }
    }
  }, [stockGlobale]);

  useEffect(() => {
    if (stockGlobale) {
      setspinner(false);
    }
  }, [stockGlobale]);

  return (
    <div>
      <Modal
        show={ShowModal}
        onHide={() => {
          setSelectedArticles(null);
          setShowModal(false);
        }}
        className="modal-1"
        dialogClassName="modal-90w"
        backdropClassName="modal-backdrop-1"
      >
        <Modal.Header>
          <Modal.Title>
            <span className="modal-title" id="addCategorieLabel">
              {" "}
              {t("Stock globale de ")}
              {article?.titre.fr}
            </span>
          </Modal.Title>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setShowModal(false);
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <div className="row">
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label={t(
                    "Consultez le stock des dépôts des articles défectueux"
                  )}
                  checked={article_defectueux}
                  onChange={handleSwitchChange}
                />
              </Form>
            </div>
            <div className="row">
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label={t("Consultez le stock 0")}
                  checked={showtotalStock}
                  onChange={() => setShowtotalStock(!showtotalStock)}
                />
              </Form>
            </div>
            <div className="list">
              <div className="row layout-spacing">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <th colSpan={3}></th>

                      <th></th>

                      {listOrganisations &&
                        listOrganisations?.map((item, index) => (
                          <>
                            {(showtotalStock ||
                              StockOrganisationshow(stockGlobale, item._id) ) && (
                              <>
                                <th
                                  className="text-center lien-bleu-souligne "
                                  style={{
                                    backgroundColor: generateUniqueColor(index),
                                  }}
                                  colSpan={
                                    showDepots && OrgDepots === item._id
                                      ? article_defectueux
                                        ? listDepots[item._id]?.length
                                        : listDepots[item._id]?.length - 1
                                      : 1
                                  }
                                  onClick={() => {
                                    setOrgDepots(
                                      OrgDepots === null ? item._id : null
                                    );
                                    setshowDepots(!showDepots);
                                  }}
                                >
                                  {
                                    listOrganisations?.find(
                                      (org) => org._id === item._id
                                    )?.nom
                                  }{" "}
                                  <p>
                                    {StockOrganisation(stockGlobale, item._id)}
                                  </p>
                                </th>
                              </>
                            )}
                          </>
                        ))}
                      {(showtotalStock ||
                        StockOrganisationshow(stockGlobale, "null") ) && (
                        <th
                          colSpan={
                            showDepots && OrgDepots === "null"
                              ? listDepots["null"]?.length
                              : 1
                          }
                          onClick={() => {
                            setOrgDepots(OrgDepots === null ? "null" : null);
                            setshowDepots(!showDepots);
                          }}
                          className="lien-bleu-souligne"
                          style={{
                            borderRight: "1px solid black",
                            backgroundColor: generateUniqueColor(-1),
                          }}
                        >
                          {t("societe")}
                          <p>{StockOrganisation(stockGlobale, "null")}</p>
                        </th>
                      )}
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            fontSize: "16px",
                          }}
                          colSpan={2}
                        >
                          <strong>{t("Article")}</strong>
                        </td>
                        <td
                          style={{
                            fontSize: "16px",
                          }}
                        >
                          <strong>{t("Prix")}</strong>
                        </td>
                        <td
                          style={{
                            borderRight: "1px solid black",
                            fontSize: "16px",
                          }}
                        >
                          <strong>{t("Stock total")}</strong>
                        </td>

                        {listOrganisations.map(
                          (item: any, index) =>
                            (showtotalStock ||
                              StockOrganisationshow(stockGlobale, item._id) ) && (
                              <>
                                {showDepots && OrgDepots === item._id ? 
                                (
                                  <>
                                    {listDepots[item._id] ? (
                                      listDepots[item._id]?.map((dep: any) =>
                                        !dep.article_defectueux ? (
                                          <>
                                            <td
                                              style={{
                                                borderRight: "1px solid black",
                                                fontSize: "17px",
                                                backgroundColor: generateUniqueColor(index),

                                              }}
                                              key={dep._id}
                                            >
                                              {dep.libelle}
                                            </td>
                                          </>
                                        ) : (
                                          article_defectueux && (
                                            <>
                                              <td
                                                style={{
                                                  fontSize: "17px",
                                                  borderRight:
                                                    "1px solid black",
                                                    backgroundColor: generateUniqueColor(index),

                                                }}
                                                key={dep._id}
                                              >
                                                {t("P.Def")}
                                              </td>
                                            </>
                                          )
                                        )
                                      )
                                    ) : (
                                      <td></td>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <td
                                      style={{
                                        borderRight: "1px solid black",
                                      }}
                                      
                                    ></td>
                                  </>
                                )}
                              </>
                            )
                        )}
                        <>
                          {(showtotalStock ||
                            StockOrganisationshow(stockGlobale, "null") ) && (
                            <>
                              {showDepots && OrgDepots === "null" ? 
                              (
                                <>
                                  {listDepots["null"] ? (
                                    listDepots["null"]?.map((dep: any) =>
                                      !dep.article_defectueux ? (
                                        <>
                                          <td
                                            style={{
                                              borderRight: "1px solid black",
                                              fontSize: "17px",
                                              backgroundColor: generateUniqueColor(-1),
                                            }}
                                            key={dep._id}
                                          >
                                            {dep.libelle}
                                          </td>
                                        </>
                                      ) : (
                                        article_defectueux && (
                                          <>
                                            <td
                                              style={{
                                                fontSize: "17px",
                                                borderRight: "1px solid black",
                                                backgroundColor: generateUniqueColor(-1),

                                              }}
                                              key={dep._id}
                                            >
                                              {t("P.Def")}
                                            </td>
                                          </>
                                        )
                                      )
                                    )
                                  ) : (
                                    <td></td>
                                  )}
                                </>
                              ) : (
                                <>
                                  <td
                                    style={{
                                      borderRight: "1px solid black",
                                    }}
                                  ></td>
                                </>
                              )}
                            </>
                          )}
                        </>
                      </tr>

                      {stockGlobale &&
                        stockGlobale !== null &&
                        stockGlobale?.map(
                          (itemdata: any, dataIndex: any) =>
                            (showtotalStock || StockArticle(itemdata) > 0) && (
                              <tr key={dataIndex}>
                                <td
                                style={{ backgroundColor: itemdata?.article?._id===article?._id ? '#FFFF33':'', fontSize: "17px" }}>
                                  {itemdata?.article?.image &&
                                  itemdata?.article?.image !== null &&
                                  itemdata?.article?.image?.length > 0 ? (
                                    <>
                                      <Zoom>
                                        <img
                                          alt="image"
                                          src={
                                            process.env
                                              .REACT_APP_API_PUBLIC_URL +
                                            "article/" +
                                            itemdata?.article.image
                                          }
                                          width="30"
                                          height="30"
                                        />
                                      </Zoom>
                                    </>
                                  ) : (
                                    <>
                                      <img
                                        src="assets/assets/img/no-image.jpg"
                                        className="card-img-top"
                                        alt="..."
                                        style={{
                                          width: "50px",
                                          height: "30px",
                                        }}
                                      />
                                    </>
                                  )}
                                </td>
                                <td  style={{ backgroundColor: itemdata?.article?._id===article?._id ? '#FFFF33':'', fontSize: "17px" }}>
                                  <p style={{ width: "200px" }}>
                                    {itemdata?.article?.titre?.fr}
                                  </p>
                                </td>
                                <td className="fontBolde " style={{ backgroundColor: itemdata?.article?._id===article?._id ? '#FFFF33':'', fontSize: "17px" }}>
                                  {itemdata?.article?.prix_vente_ttc.toFixed(3)}
                                </td>
                                <td
                                  style={{
                                    borderRight: "1px solid black",
                                    backgroundColor: itemdata?.article?._id===article?._id ? '#FFFF33':'', fontSize: "17px" 
                                  }}
                                  className="fontBolde "
                                >
                                  {" "}
                                  <p>{StockArticle(itemdata)}</p>
                                </td>

                                {listOrganisations?.map((orgId, indexOrg) => (
                                  <React.Fragment key={indexOrg}>
                                    {
                                    (showtotalStock ||
                                      StockOrganisationshow(
                                        stockGlobale,
                                        orgId._id
                                      ) ) &&
                                      (showDepots && orgId._id === OrgDepots ? 
                                        (
                                        <React.Fragment key={indexOrg}>
                                          {listDepots[orgId._id] ? (
                                            listDepots[orgId._id]?.map(
                                              (dep: any, index: any) => (
                                                <React.Fragment key={index}>
                                                  {!dep.article_defectueux ? (
                                                    <>
                                                      <td
                                                        className="fontBolde "
                                                        onClick={() => {
                                                          setOrgDepots(null);
                                                          setshowDepots(
                                                            !showDepots
                                                          );
                                                        }}
                                                        style={{
                                                          borderRight:
                                                            "1px solid black",
                                                            backgroundColor: generateUniqueColor(indexOrg),

                                                        }}
                                                      >
                                                        {}
                                                        {itemdata?.stock[
                                                          orgId?._id
                                                        ]?.find(
                                                          (d: any) =>
                                                            d.depots_id?._id ===
                                                            dep?._id
                                                        )?.stock || 0}
                                                      </td>
                                                    </>
                                                  ) : (
                                                    article_defectueux && (
                                                      <td
                                                        className="fontBolde "
                                                        style={{
                                                          borderRight:
                                                            "1px solid black",
                                                            backgroundColor: generateUniqueColor(indexOrg),

                                                        }}
                                                        onClick={() => {
                                                          setOrgDepots(null);
                                                          setshowDepots(
                                                            !showDepots
                                                          );
                                                        }}
                                                      >
                                                        {itemdata?.stock[
                                                          orgId._id
                                                        ]?.find(
                                                          (d: any) =>
                                                            d.depots_id
                                                              ?.article_defectueux
                                                        )?.stock || 0}
                                                      </td>
                                                    )
                                                  )}
                                                </React.Fragment>
                                              )
                                            )
                                          ) : (
                                            <td></td>
                                          )}
                                        </React.Fragment>
                                      ) : (
                                        <>
                                          <td
                                            className="fontBolde "
                                            onClick={() => {
                                              setOrgDepots(orgId._id);
                                              setshowDepots(!showDepots);
                                            }}
                                            style={{
                                              borderRight: "1px solid black",
                                              backgroundColor: generateUniqueColor(indexOrg),


                                            }}
                                          >
                                            {itemdata?.stock[orgId._id]?.reduce(
                                              (acc: any, rec: any) =>
                                                acc + (rec.stock || 0),
                                              0
                                            ) || 0}
                                          </td>
                                        </>
                                      ))}
                                     
                                  </React.Fragment>
                                ))}
                                <React.Fragment>
                                  {(showtotalStock ||
                                    StockOrganisationshow(stockGlobale, "null")) &&
                                    (showDepots && "null" === OrgDepots ? (
                                      <React.Fragment>
                                        {listDepots["null"] ? (
                                          listDepots["null"]?.map(
                                            (dep: any, index: any) => (
                                              <React.Fragment key={index}>
                                                {!dep.article_defectueux ? (
                                                  <>
                                                    <td
                                                      className="fontBolde "
                                                      onClick={() => {
                                                        setOrgDepots(null);
                                                        setshowDepots(
                                                          !showDepots
                                                        );
                                                      }}
                                                      style={{
                                                        borderRight:
                                                          "1px solid black",
                                                          backgroundColor: generateUniqueColor(-1),

                                                      }}
                                                    >
                                                      {itemdata?.stock[
                                                        "null"
                                                      ]?.find(
                                                        (d: any) =>
                                                          d.depots_id._id ===
                                                          dep._id
                                                      )?.stock || 0}
                                                    </td>
                                                  </>
                                                ) : (
                                                  article_defectueux && (
                                                    <td
                                                      className="fontBolde "
                                                      style={{
                                                        borderRight:
                                                          "1px solid black",
                                                          backgroundColor: generateUniqueColor(-1),

                                                      }}
                                                      onClick={() => {
                                                        setOrgDepots(null);
                                                        setshowDepots(
                                                          !showDepots
                                                        );
                                                      }}
                                                    >
                                                      {itemdata?.stock[
                                                        "null"
                                                      ]?.find(
                                                        (d: any) =>
                                                          d.depots_id
                                                            .article_defectueux
                                                      )?.stock || 0}
                                                    </td>
                                                  )
                                                )}
                                              </React.Fragment>
                                            )
                                          )
                                        ) : (
                                          <td></td>
                                        )}
                                      </React.Fragment>
                                    ) : (
                                      <>
                                        <td
                                          className="fontBolde "
                                          onClick={() => {
                                            setOrgDepots("null");
                                            setshowDepots(!showDepots);
                                          }}
                                          style={{
                                            borderRight: "1px solid black",
                                            backgroundColor: generateUniqueColor(-1),

                                          }}
                                        >
                                          {itemdata?.stock["null"]?.reduce(
                                            (acc: any, rec: any) =>
                                              acc + (rec.stock || 0),
                                            0
                                          ) || 0}
                                        </td>
                                      </>
                                    ))}
                                </React.Fragment>
                              </tr>
                            )
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StockGlobale;
